module.exports = __webpack_public_path__ + "img/registration_form_schema.b19e3181.svg";